import { sdk } from '@/utils/coode-sdk';
export default class BaseService {
    protected api: any;
    constructor(baseURL?: string) {
        this.api = sdk?.backend.request.api;
        this.api.setBaseUrl(baseURL ? baseURL : process.env.VUE_APP_API_BASE_URL);
    }
}
